<template>
  <div class="container order-list">
    <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>

    <div class="content c-top">
      <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
      <div class="lForm">
        <el-form :inline="true" id="searchForm" :model="searchForm" ref="searchForm" label-width="70px">
          <el-form-item label="商品名称" prop="orderNo">
            <el-input v-model.trim="searchForm.goodsName" size="small" placeholder="请输入商品名称" filterable
              clearable></el-input>
          </el-form-item>
          <el-form-item label="下单用户" prop="orderNo">
            <el-input v-model.trim="searchForm.userInfo" size="small" placeholder="请输入下单用户" filterable
              clearable></el-input>
          </el-form-item>
          <el-form-item label="收货人" prop="postUserInfo">
            <el-input v-model.trim="searchForm.postUserInfo" size="small" placeholder="收货人信息" clearable></el-input>
          </el-form-item>
          <el-form-item label="订单编号" prop="orderNo">
            <el-input v-model.trim="searchForm.orderNo" size="small" placeholder="请输入订单编号" filterable
              clearable></el-input>
          </el-form-item>
          <el-form-item label="物流编号" prop="orderNo">
            <el-input v-model.trim="searchForm.logisticsNumber" size="small" placeholder="请输入物流编号" filterable
              clearable></el-input>
          </el-form-item>
          <el-form-item label="订单类型" prop="orderType">
            <el-select v-model="searchForm.orderType" placeholder="请选择订单类型" size="small" filterable clearable>
              <el-option v-for="item in dictionaries.platform_order_type" :key="item.dictId" :label="item.dictName"
                :value="item.dictId">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="订单状态" prop="orderStatus">
            <el-select
              v-model="searchForm.orderStatus"
              placeholder="请选择订单状态"
              size="small"
              filterable
              clearable
            >
              <el-option
                v-for="item in dictionaries.platform_order_status"
                :key="item.dictId"
                :label="item.dictName"
                :value="item.dictId"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="创建时间" prop="createdTime">
            <el-date-picker v-model="createTime" type="daterange" size="small" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="支付时间" prop="createdTime">
            <el-date-picker v-model="payTime" type="daterange" size="small" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="来源平台" prop="miniAppId">
            <el-select style="width: 232px" v-model="searchForm.miniAppId" placeholder="请选择来源平台" filterable clearable
              size="small">
              <el-option v-for="item in apps" :key="item.appid" :label="item.name" :value="item.appid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="来源类型" prop="originType">
            <el-select style="width: 232px" v-model="searchForm.platformOrderOriginType" placeholder="请选择来源类型" clearable
              size="small">
              <el-option v-for="item in dictionaries.platform_order_origin_type" :key="item.dictId" :label="item.dictName"
                :value="item.dictId">
              </el-option>
              <!-- <el-option label="广告引流" value="1"></el-option>
              <el-option label="回流流量" value="2"></el-option>
              <el-option label="自然流量" value="3"></el-option> -->
            </el-select>
          </el-form-item>

          <el-form-item label=" " label-width="0px" style="margin-left:-6px">
            <el-button type="primary" size="small" @click="fetchData('search')"
              @keyup.enter="fetchData('search')">查询</el-button>
            <el-button type="primary" plain size="small" @click="fetchData('reset')">重置
            </el-button>
          </el-form-item>
        </el-form>
        <div style="height:10px"></div>
      </div>
    </div>
    <div class="content">
      <h3>数据列表</h3>

      <div class="btn-list tabclass">
        <div class="">
          <el-radio-group v-model="radio1" @change="selectData">
            <el-radio-button label=" " border>全部({{ statusCount.totalCount }})</el-radio-button>
            <el-radio-button label="1">待付款({{ statusCount.waitingPayCount }})</el-radio-button>
            <el-radio-button label="2">待备货({{ statusCount.waitingStockingCount }})</el-radio-button>
            <el-radio-button label="3">已备货({{ statusCount.stockedCount }})</el-radio-button>
            <el-radio-button label="4">待发货({{ statusCount.waitingDeliveryCount }})</el-radio-button>
            <el-radio-button label="5">已发货({{ statusCount.deliveredCount }})</el-radio-button>
            <el-radio-button label="6">已收货({{ statusCount.receivedCount }})</el-radio-button>
            <el-radio-button label="7">已取消({{ statusCount.closedCount }})</el-radio-button>
            <!-- <el-radio-button label="99">异常订单({{ statusCount.errorCount }})</el-radio-button> -->
          </el-radio-group>
        </div>
        <div>
          <el-button type="primary" :loading="exportLoading" icon="el-icon-upload2"
            @click="monthExport">导出本月订单数据</el-button>
          <el-button type="primary" :loading="exportLoading" @click="lotsExport" icon="el-icon-upload2">批量导出</el-button>
        </div>
      </div>
      <orders-list-table :dataList="page.list" :heightStr="columns.height" :config="columnCommon.config"
        typeStr="logisticsOrder" @tableSelectionChange="handleSelectionChange"></orders-list-table>
      <!-- 分页start -->
      <div class="page">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="searchForm.pageNo" :page-sizes="[3, 5, 10, 20, 50]" :page-size="searchForm.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="page.totalNum">
        </el-pagination>
      </div>
      <!-- 分页end -->
    </div>
  </div>
</template>

<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import ordersListTable from '../components/ordersListTableL'
export default {
  components: {
    ordersListTable,
    breadcrumbTop,
    breadcrumbSearch
  },
  data() {
    return {
      radio1: ' ',
      searchList: {
        list: [
          { title: '物流订单', path: '', type: '0' },
          { title: '数据筛选', path: '', type: '1' }
        ]
      },
      dataList: {
        list: [
          { title: '订单管理', path: '', type: '0' },
          { title: '物流订单', path: '', type: '1' }
        ]
      },
      exportLoading: false,
      loadingState: false,
      loadingStateTwo: false,
      loadingStateThree: false,
      loadingStateFour: false,
      loading: false,
      parArray: [],
      userType: '',
      columns: {
        type: 'all',
        height: '5000px',
        sortObj: {},
        config: []
      },
      // 公共  column
      columnCommon: {
        type: 'common',
        sortObj: { prop: 'marketPrice', order: 'descending' }, // 排序
        config: [
          { type: 'selection', width: 50 },
          { prop: 'payTypeLabel', label: '商品信息', width: 200, slot: 'goods' },
          { prop: 'quantity', label: '总数量', width: 60 },
          { prop: 'goodsAmount', label: '总金额(元)', width: 120, slot: 'goodsAmount' },
          { prop: 'miniAppName', label: '来源平台', width: 120, },
          { prop: 'userName', label: '下单用户', width: 120, slot: 'user' },
          { prop: 'postName', label: '收货人', width: 120, slot: 'postName' },
          { prop: 'statusLabel', label: '订单状态', width: 80, slot: 'order' },
          // { prop: 'discountAmount', label: '优惠金额', width: 100, slot: 'discountAmount' },
          { prop: 'receivedAmount', label: '实收金额', width: 120, slot: 'amount' },
          // { prop: 'userCommission', label: '用户佣金', width: 150, slot: 'userCommission', align: 'center' },
          // {
          //   prop: 'vipCommission', label: '服务商佣金', width: 150, slot: 'vipCommission', align: 'center'
          // },
          {
            prop: ' ', label: '操作', width: 100, align: 'left'
          }
        ]
      },
      multipleSelection: '', // 多选
      cancelOrderId: '', // 取消订单id
      setCloseOrder: '', // 取消订单参数
      statusCount: { // 物流订单分页数量统计
        totalCount: 100, // 全部数量
        waitingPayCount: 12,
        waitingStockingCount: 12,
        stockedCount: 12,
        deliveredCount: 13,
        waitingDeliveryCount: 14,
        receivedCount: 10,
        closedCount: 10,
        errorCount: 0
      },
      searchForm: {
        ids: [],
        goodsName: null,
        userInfo: null,
        postUserInfo: null,
        orderNo: null,
        logisticsNumber: null,
        orderType: null,
        orderStatus: null,
        createTimeStart: null,
        createTimeEnd: null,
        payTimeStart: null,
        payTimeEnd: null,
        pageNo: 1,
        pageSize: 10,
        platformOrderOriginType: '',
        miniAppId: ''
      },
      currentTab: '', // 当前列表状态
      // 分配状态
      currentTabStatus: {
        all: '', // 全部
        beforePay: 1, // 待支付
        choicing: 2, // 备货中
        signFor: 3, // 待签收
        accomplish: 4, // 已完成
        afterSale: 6 // 已关闭
      },
      columnTitle: this.column,
      breadcrumbConfig: {
        list: [
          {
            title: '订单管理',
            type: '#ff0000',
            path: ''
          },
          {
            title: '运营订单',
            type: '1',
            path: ''
          }

        ]
      },
      page: { list: [], pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      rQuery: {},
      afterSale: '',
      dictionaries: {},
      createTime: [],
      payTime: [],
      apps: [],
    }
  },
  watch: {
    $route: {
      handler(val, oldVal) {

      },
      // 深度观察监听
      deep: true
    }
  },
  created() {
    this.getDictionaries('platform_order_type')
    this.getDictionaries('platform_order_status')
    this.getDictionaries('platform_order_origin_type')
    this.fetchData()// 初始化，搜索需要的列表数据
    this.getAppList()
    this.getCount()
  },
  mounted() {
    // this.$nextTick(_ => {
    //   const rQuery = this.rQuery
    //   if (rQuery.state) {
    //     this.onChangeCurrentTab(Number(rQuery.state))
    //     this.currentTab = rQuery.state || ''
    //   } else {
    //     this.onChangeCurrentTab() // fetchData 在这里执行
    //   }
    //   console.log('this.currentTab = ', this.currentTab)
    // })
  },
  methods: {
    getAppList() {
      this.axios.get('/miniApp/getMiniAppIdName').then(res => {
        if (res.code == 0) {
          this.apps = res.data
        }
      })
    },
    getCount() {
      this.searchForm.orderStatus = null
      this.axios.post('/orders/getStatusCount', this.searchForm).then(res => {
        if (res.code == 0) {
          this.statusCount = res.data
        }
      })
    },
    selectData() {
      this.searchForm.orderStatus = this.radio1
      this.fetchData()
    },
    //批量导出
    lotsExport() {
      let ids = []
      if (this.multipleSelection) {
        this.multipleSelection.forEach(item => {
          ids.push(item.id)
        })
      }
      this.exportLoading = true
      this.searchForm.ids = ids
      this.searchForm.orderStatus = this.radio1
      this.axios.post('/orders/export', this.searchForm).then(res => {
        if (res.code == 0) {
          this.exportLoading = false
          this.$message.success('导出成功')
          this.downloadlink(res.data)
        }
      })
      // if (ids.length == 0 && this.searchForm == {}) {
      //   this.$message.warning('请选择导出数据')
      //   return
      // } else {
      //   this.exportLoading = true
      //   this.searchForm.ids = ids
      //   this.axios.post('/orders/export', this.searchForm).then(res => {
      //     if (res.code == 0) {
      //       this.exportLoading = false
      //       this.$message.success('导出成功')
      //       this.downloadlink(res.data)
      //     }
      //   })
      // }
    },
    //导出本月数据
    monthExport() {
      this.exportLoading = true
      this.axios.post('/orders/monthlyExport', {}).then(res => {
        if (res.code == 0) {
          this.exportLoading = false
          this.$message.success('导出成功')
          this.downloadlink(res.data)
        }
      })
    },
    downloadlink(url) {
      const protocol = location.protocol
      let resultUrl = url
      if (protocol === 'https:') {
        resultUrl = url.replace(`http:`, `${protocol}`)
      }
      const iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      iframe.src = resultUrl
      document.body.appendChild(iframe)
    },
    // 获取字典数据
    getDictionaries(type) {
      this.axios.get('/sys/dictByGroup', {
        params: {
          groupId: type
        }
      })
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.dictionaries[type] = res.data
          }
        })
    },
    onChangeCurrentTab(status) {
      this.page.pageNo = 1
      this.page.pageSize = 10
      this.page.currentPage = 1
      let strTemp = 'all'
      let configTemp = [...this.columnCommon.config]
      this.columns.type = strTemp
      this.columns.config = Array.from(new Set(configTemp))
      this.fetchData('search')
    },
    fetchData(type) {
      this.loading = true
      if (type == 'reset') {
        this.searchForm = {}
        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
        this.createTime = []
        this.payTime = []
      }
      if (type == 'search') {
        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
        this.searchForm.orderStatus = this.radio1
      }
      if (this.createTime) {
        this.searchForm.createTimeStart = this.createTime[0]
        this.searchForm.createTimeEnd = this.createTime[1]
      }
      if (this.payTime) {
        this.searchForm.payTimeStart = this.payTime[0]
        this.searchForm.payTimeEnd = this.payTime[1]
      }

      this.axios.post('/orders/pageList', this.searchForm).then((res) => {
        if (res.code === 0) {
          this.page.list = res.data.list
          this.page.totalNum = res.data.totalNum
          // if(this.currentTab === 1){params.status = 1}
          // this.getStatusCount(params)// 订单数量统计查询
          this.loading = false
          this.getCount()
        } else {
          console.log('goodsPageList - 失败', type)
        }
      }).catch((err) => {
        console.log(err)
        this.loading = false
      })
    },
    handleCurrentChange(currentChange) {
      this.searchForm.pageNo = currentChange
      this.fetchData()
      console.log(currentChange, 'currentChange')
    },
    handleSizeChange(sizeChange) {
      this.searchForm.pageSize = sizeChange
      this.fetchData()
    },

    // 订单数量统计查询
    getStatusCount(params) {
      // const params = {}
      this.$api.getStatusCount(params).then((res) => {
        this.statusCount = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    // 初始化，搜索需要的列表数据
    initSearchList() {
      const params = { pageNo: 1, pageSize: 1001 }
      // this.getPlatformDataList(params) // 平台
      // this.getShopDataList(params) // 店铺
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
      console.log(this.multipleSelection)
    }
  }
}
</script>

<style scoped lang="scss">
.lForm {
  .el-input {
    width: 232px !important;
  }

  .el-select {
    width: 232px !important;
  }

  .el-range-editor {
    width: 232px !important;
  }
}

::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner {
  color: #2d46ee;
  background-color: #fff !important;
  border-color: #2d46ee;
  box-shadow: -1px 0 0 0 #2d46ee;
}

.page {
  text-align: right;
  margin: 10px auto;
}

/deep/ .hide-content {
  display: none !important;
}

/deep/ .show-content {
  display: inline-block;
}

/deep/ .el-link {
  margin: 0 5px;
}

.search-form .el-form-item {
  width: 100%;
  // max-width: 295px;
  width: 250px;
  margin-right: 10px;
}

/deep/ .el-table th>.cell,
/deep/ .el-table td {
  text-align: unset;
}

.tabclass {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.yellowBtn,
.blueBtn,
.serviceDerive,
.promotionDerive {
  height: 36px;
  border-radius: 4px;
  margin-bottom: 10px;
}

.yellowBtn {
  //width: 160px;
  //height: 36px;
  background: #edb840;
  //border-radius: 4px;
}

.blueBtn {
  //width: 120px;
  //height: 36px;
  background: #4168e7;
  //border-radius: 4px;
}

.serviceDerive {
  //width: 160px !important;
  background: #67c23a !important;
}

.promotionDerive {
  //width: 160px !important;
  background: #e6a23c !important;
}

.serviceDeriveTwo {
  //width: 160px !important;
  background: #0f82c5 !important;
}

.promotionDeriveTwo {
  //width: 160px !important;
  background: #b705fd !important;
}

.tabBtn {
  //width: 100px;
  height: 36px;
  padding: 0 12px;
  border-radius: 4px;
  margin-bottom: 10px;
}

/deep/ .el-tabs {
  margin-top: 20px;

  .el-tabs__header {
    .el-tabs__nav-wrap {
      .el-tabs__nav-scroll {
        padding: 0;

        .el-tabs__nav {
          .el-tabs__active-bar {
            display: none;
          }

          .el-tabs__item {
            margin-right: 20px;
            width: 120px;
            height: 36px;
            padding: 0;
            text-align: center;
            line-height: 36px;
            font-size: 16px;
            color: #999999;
            border-radius: 4px;
            background: #ececec;
          }

          .el-tabs__item.is-active {
            color: #333333;
            background: #e3edff;
          }
        }
      }
    }
  }

  .el-tabs__nav-wrap::after {
    display: none;
  }
}

.shopTitle {
  margin-bottom: 20px;
}

// /deep/ .el-button {
//   border: none;
// }

.search-form {
  .el-form-item {
    max-width: 312px;

    /deep/ .el-form-item__label {
      width: 100px;
    }

    /deep/ .el-form-item__content {
      width: calc(100% - 100px);

      // .el-date-editor {
      //   //width: calc(100% - 82px);
      // }
    }
  }
}

.orderNotes {
  margin-top: 24px;
  padding-bottom: 25px;
  border-bottom: 1px solid #d9d9d9;

  .headerOrder {
    .orderRemak {
      margin-bottom: 12px;
      font-size: 18px;
    }
  }
}

/deep/ .el-textarea__inner {
  height: 132px;
}

.statistics {
  margin-top: 30px;
  display: flex;
  justify-content: right;
  align-items: center;

  .fourteen {
    font-size: 14px;
    padding-right: 20px;
  }

  .blue {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 0px;
    color: #4168e7;
  }
}

.present {
  display: flex;
  justify-content: right;
  height: 36px;
  margin-top: 30px;
  padding-bottom: 28px;
}

.tabsBtn {
  display: flex;
}

.dialogBtnright {
  display: flex;
  justify-content: space-between;
}

.dialogBtnright_right {
  display: flex;
  justify-content: right !important;
}

.setPay_payment_btn_quxiao {
  width: 120px;
  height: 36px;
  border: 1px solid #d9d9d9;
  background-color: #ffffff;
  color: rgba(153, 153, 153, 1);
  border-radius: 4px;
  line-height: 0;
}

.setPay_payment_btn_queren {
  width: 120px;
  height: 36px;
  background: #4168e7;
  opacity: 1;
  border-radius: 4px;
  line-height: 0;
  border: 0;
}

.setPay_payment {
  display: block;
  margin-bottom: 15px;
}

.dialog-btn {
  text-align: right;
}

/deep/ .el-table__row td .cell p {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  /* 可以显示的行数，超出部分用...表示*/
  -webkit-box-orient: vertical;
}

/*
/deep/.el-table__row td .cell span, /deep/.el-table__row td .cell div p{
  display: block;
  overflow : hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
*/
/deep/ .el-scrollbar {
  height: 10px;
}

/deep/ .el-scrollbar__bar.is-horizontal {
  height: 9px;
}

::v-deep .el-form-item__label {
  padding: 0px 10px 0 0;
}
</style>
